import React, { type ComponentPropsWithRef } from 'react';
import { type VariantProps } from 'class-variance-authority';
import { buttonStyles } from './helpers';
import { clsxMerge } from '../../utils/classNameUtils';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

type ButtonElementProps = ComponentPropsWithRef<'button'>;

export interface ButtonProps
    extends ButtonElementProps,
        VariantProps<typeof buttonStyles> {
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    text?: string;
    variant?:
        | 'primary'
        | 'primaryInvert'
        | 'secondary'
        | 'secondaryOutline'
        | 'tertiary'
        | 'tertiaryOutline'
        | 'error'
        | 'errorOutline'
        | 'errorNoOutline'
        | 'errorSecondary';
    isLoading?: boolean;
    disabled?: boolean;
}

const Button = ({
    className,
    size,
    text,
    rightIcon,
    leftIcon,
    variant,
    isLoading,
    disabled,
    ...props
}: ButtonProps) => {
    return (
        <button
            className={clsxMerge(buttonStyles({ variant, size }), className)}
            disabled={disabled || isLoading}
            {...props}
        >
            {Boolean(leftIcon) && leftIcon}
            {Boolean(text) && text}
            {Boolean(rightIcon) && rightIcon}
            {isLoading && (
                <Spin
                    indicator={
                        <LoadingOutlined
                            style={{ fontSize: 24, color: 'white' }}
                            spin
                        />
                    }
                />
            )}
        </button>
    );
};

export default Button;
